<template>
  <v-scale-transition>
    <panel
      :breadcrumbs="breadcrumbs"
      :title="title"
    >
      <v-toolbar
        card
        extended
      >
        <v-container fluid>
          <v-layout row>
            <v-flex xs3>
              <v-select
                v-model="select"
                :items="selects"
                item-text="text"
                item-value="value"
                label="Filter By"
              />
            </v-flex>
            <v-spacer />
            <v-spacer />
            <v-spacer />
            <v-text-field
              v-model="dealer"
              append-icon="search"
              label="Enter dealer"
              clearable
            />
            <v-spacer />
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="primary"
                dark
                class="mb-2"
                @click="refreshList()"
              >
                Search
              </v-btn>
            </v-card-actions>
          </v-layout>
        </v-container>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="items"
        class="elevation-1"
      >
        <template #items="props">
          <td class="text-xs-left">
            {{ props.item.dealerId }}
          </td>
          <td class="text-xs-left">
            {{ props.item.name }}
          </td>
          <td class="text-xs-left">
            {{ props.item.msisdn }}
          </td>
          <td class="text-xs-center">
            {{ props.item.plan }}
          </td>
          <td class="text-xs-left">
            {{ props.item.active }}
          </td>
          <td class="text-xs-left">
            {{ props.item.balance }}
          </td>
        </template>
      </v-data-table>
      <v-dialog
        v-model="executeDialog"
        max-width="500px"
      >
        <template #activator="{ on }">
          <v-btn
            color="primary"
            dark
            class="mb-2"
            v-on="on"
          >
            Transfer Dealer
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Execute Transfer Dealer</span>
          </v-card-title>

          <v-alert
            :value="true"
            :type="executeAlertType"
            v-html="executeAlertMessage"
          />

          <v-card-actions>
            <v-spacer />
            <v-btn
              color="blue darken-1"
              flat
              @click="executeDialog = false"
            >
              {{ executeAlertType === "info" ? "Cancel" : "Close" }}
            </v-btn>
            <v-btn
              v-show="executeAlertType === 'info'"
              :loading="loading"
              color="blue darken-1"
              flat
              @click="executeTransferDealer"
            >
              Execute
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </panel>
  </v-scale-transition>
</template>

<script>
import { createGetParams, createPostParams } from '@/rest'

const pageTitle = 'Transfer Dealer Erecharge'

export default {
  components: {
    Panel: () => import(/* webpackChunkName: "panel" */ '@/components/Panel'),
  },
  data: () => ({
    title: pageTitle,
    items: [],
    dealer: null,
    executeDialog: false,
    executeAlertType: 'info',
    executeAlertMessage: null,
    loading: false,
    select: 1,
    selects: [
      {
        text: 'Prepaid',
        value: 1,
      },
      {
        text: 'Postpay',
        value: 2,
      },
    ],
    breadcrumbs: [
      {
        text: 'Technical Kits',
        disabled: false,
        to: '/technical/technical_kits',
      },
      {
        text: pageTitle,
        disabled: true,
      },
    ],
    headers: [
      {
        text: 'Dealer Id',
        align: 'left',
        sortable: true,
        value: 'dealer',
      },
      {
        text: 'Name',
        align: 'left',
        sortable: true,
        value: 'name',
      },
      {
        text: 'Msisdn',
        align: 'left',
        sortable: true,
        value: 'msisdn',
      },
      {
        text: 'Plan',
        align: 'center',
        sortable: true,
        value: 'plan',
      },
      {
        text: 'Dealer Status',
        align: 'left',
        sortable: true,
        value: 'active',
      },
      {
        text: 'ER Balance',
        align: 'left',
        sortable: true,
        value: 'balance',
      },
    ],
    editedIndex: -1,
    reactivateDealer: {
      dealer: null,
    },
    defaultDealer: {
      dealer: null,
    },
  }),
  watch: {
    executeDialog (val) {
      if (val) {
        this.executeAlertType = 'info'
        this.executeAlertMessage =
          '<div>Click <strong>EXECUTE</strong> only when you are sure that all dealer info are correct with the info given by DMT.</div>'
      }
    },
  },
  methods: {
    async getTransferDealerInfo () {
      this.loading = true
      const params = createGetParams({
        dealer: this.dealer,
        select: this.select,
      })
      try {
        this.source = this.$rest.CancelToken.source()
        Object.assign(params, { cancelToken: this.source.token })
        const response = await this.$rest.get('getErechargeDealer.php', params)
        this.items = response.data.items
      } catch (error) {
        if (!this.$rest.isCancel(error)) {
          this.hint = error.message
        }
        this.items = []
      } finally {
        this.loading = false
      }
    },
    refreshList () {
      this.getTransferDealerInfo()
    },
    async executeTransferDealer () {
      const params = createPostParams({
        action: 'transferERTechnical',
        payload: {
          target: this.dealer,
          select: this.select,
        },
      })

      try {
        this.loading = true
        await this.$rest.post('postAction.php', params)
        this.$nextTick(() => {
          this.executeAlertType = 'success'
          this.executeAlertMessage =
            'You have successfully transfer dealer`s ER to DMT'
          this.dealer = []
        })
      } catch (e) {
        this.$nextTick(() => {
          this.executeAlertType = 'error'
          this.executeAlertMessage = e.message + ': ' + e.response.data
        })
      } finally {
        this.loading = false
      }
    },
    showError (message) {
      this.alertMessage = message
      this.alert = true
    },
  },
}
</script>
